import Api from '../../services/Api';
import EventBus from '../../js/event-bus';
import { SETTINGS_POLL_INTERVAL_MS } from '../../js/constants';

// Guard de módulo (no reactivo, mismo patrón que lastGisWarmupPlantationId en Gis.js):
// evita arrancar más de un setInterval si newLoggedUser se emite varias veces en la
// misma sesión de la SPA (p.ej. tras un refresh de token que reemite el evento).
let pollIntervalId = null;

export default {
  namespaced: true,
  state: {
    // "v2" por defecto: mismo fallback seguro que aplica el backend
    // (timac_django SystemSettings.gis_version) si /settings/public no ha
    // respondido todavía o falla.
    gisVersion: 'v2',
  },
  getters: {
    isGisV2: (state) => state.gisVersion === 'v2',
  },
  mutations: {
    setGisVersion(state, value) {
      state.gisVersion = value;
    },
  },
  actions: {
    initialize({ dispatch }) {
      EventBus.$on('newLoggedUser', () => {
        dispatch('fetchGisVersion');
        if (!pollIntervalId) {
          pollIntervalId = setInterval(() => dispatch('fetchGisVersion'), SETTINGS_POLL_INTERVAL_MS);
        }
      });
    },
    // No hay companyId: gis_version es un ajuste global, no ligado a una company.
    // Fire-and-forget respecto al llamador (authentication/initialize no espera esta
    // promesa): un fallo aquí no debe bloquear el login ni el arranque de la app,
    // simplemente se mantiene el último valor conocido (o el default "v2").
    async fetchGisVersion({ commit }) {
      try {
        const response = await Api.getElement('/settings/public', {}, null, 8000);
        const { gis_version: gisVersion } = JSON.parse(response.response);
        commit('setGisVersion', gisVersion);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.warn('No se pudo obtener gis_version, se mantiene el último valor conocido', error);
      }
    },
  },
};
